import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";

const benefits = [
  {
    icon: "ri-line-chart-line",
    title: "INCREMENTA TU PATRIMONIO",
    text: "La inversión inmobiliaria es una alternativa para construir patrimonio a largo plazo.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "FLUJO DE ARRIENDO MENSUAL",
    text: "Potencial de generar ingresos mediante el arriendo de una propiedad.",
  },
  {
    icon: "ri-bank-line",
    title: "VENTAJA TRIBUTARIA DFL2",
    text: "Propiedades DFL2 con beneficios asociados. Te recomendamos consultar los detalles con tu asesor tributario.",
  },
  {
    icon: "ri-funds-line",
    title: "MAYOR PLUSVALÍA",
    text: "Potencial de valorización de una propiedad según su ubicación, desarrollo urbano y condiciones del mercado.",
  },
  {
    icon: "ri-shield-star-line",
    title: "PÓLIZA DE SEGURO DE GARANTÍA — VENTA EN VERDE",
    text: "SIN COSTO",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "GASTOS NOTARIALES DE PROMESA",
    text: "SIN COSTO",
  },
];

export default function Investment() {
  return (
    <section className="px-4 md:px-8 lg:px-12 py-20 md:py-28 bg-background-100/70">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        <Reveal>
          <SectionHeading
            eyebrow="Inversión"
            title="Invierte en proyectos pensados para crecer contigo"
          />
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <Reveal key={benefit.title} delay={index * 80}>
              <div className="flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-50 p-7 h-full hover:-translate-y-1.5 transition-transform duration-500">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${benefit.icon} text-xl`} />
                </span>
                <h3 className="font-heading text-xl text-foreground-900 leading-snug">
                  {benefit.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{benefit.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="flex justify-center">
          <Link
            to="/inversion"
            className="inline-flex items-center gap-2 rounded-md border border-foreground-900 text-foreground-900 hover:bg-foreground-900 hover:text-background-50 text-sm font-semibold px-6 py-3 transition-colors duration-300 whitespace-nowrap"
          >
            Conoce más sobre inversión
            <i className="ri-arrow-right-line" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}